import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    padding: [15, 0, 22, 0],
    borderBottom: `1px solid ${theme.palette.colors.border}`,
    cursor: 'pointer',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  upperBar: {
    display: 'flex',
    padding: [0, theme.spacing(2)],
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.colors.border}`,
    width: '100%',
  },
  buyerInfo: {
    display: 'flex',
    alignItems: 'center',
  },
  name: {
    lineHeight: '20px',
    width: 140,
    marginLeft: theme.spacing(2),
  },
  active: {
    borderRight: `2px solid ${theme.palette.colors.red}`,
    backgroundColor: theme.palette.colors.lightGray,
  },
  inActive: {
    '&:hover': {
      borderRight: `2px solid ${theme.palette.colors.gray}`,
    },
  },
  bottomBar: {
    padding: [0, theme.spacing(2)],
    display: 'flex',
    height: 55,
  },
  bottomBarItem: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    height: '100%',
  },
  bottomBarLeft: {
    width: 110,
  },
  bottomBarCenter: {
    width: 80,
  },
  bottomBarRight: {
    width: 140,
  },
  additionalText: {
    marginTop: 5,
    color: theme.palette.colors.darkBlueGray,
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
}));



// WEBPACK FOOTER //
// ./src/components/LoanOfficerMessages/components/MobileMessages/components/ChatPage/components/BuyerCard/useStyles.js